(function () {
  'use strict';

  var modal    = document.getElementById('quick-view-modal');
  var gallery  = document.getElementById('quick-view-gallery');
  var info     = document.getElementById('quick-view-info');
  var closeBtn = document.getElementById('quick-view-close');
  var backdrop = document.getElementById('overlay-backdrop');

  if (!modal) return;

  /* ── open / close ── */
  function openModal() {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    backdrop && backdrop.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }
  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (backdrop && !document.querySelector('.cart-drawer.is-open')) {
      backdrop.classList.remove('is-visible');
    }
  }

  closeBtn && closeBtn.addEventListener('click', closeModal);
  modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

  /* ── fetch + render ── */
  async function openQuickView(handle) {
    openModal();
    gallery.innerHTML = '<div class="qv-loading-state"><div class="loading-spinner"></div></div>';
    info.innerHTML    = '<div class="qv-loading-state"><div class="loading-spinner"></div></div>';

    try {
      const res     = await fetch('/products/' + handle + '.js');
      const product = await res.json();
      renderQuickView(product);
    } catch (e) {
      info.innerHTML = '<p style="padding:2rem;color:var(--c-dark-gray);">Could not load product.</p>';
    }
  }

  function imgUrl(src, size) {
    return src
      .replace(/\.jpg(\?.*)?$/, '_' + size + '.jpg')
      .replace(/\.png(\?.*)?$/, '_' + size + '.png')
      .replace(/\.webp(\?.*)?$/, '_' + size + '.webp');
  }

  function moneyFormat(cents) {
    return 'EGP ' + (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function renderQuickView(product) {
    var imgs = product.images.slice(0, 6);
    var selectedVariant = product.variants[0];
    var selectedOptions = selectedVariant.options.slice();

    /* ── Gallery ── */
    if (imgs.length) {
      gallery.innerHTML =
        '<div class="qv-gallery__main">' +
          '<img src="' + imgUrl(imgs[0], '900x') + '" alt="' + product.title + '" id="qv-main-img" class="qv-gallery__main-img">' +
          '<div class="qv-gallery__zoom-hint">'+
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>' +
            'Hover to zoom' +
          '</div>' +
        '</div>' +
        '<div class="qv-gallery__thumbs" id="qv-thumbs">' +
          imgs.map(function (img, i) {
            return '<button class="qv-gallery__thumb ' + (i === 0 ? 'is-active' : '') + '" data-full="' + imgUrl(img, '900x') + '" type="button">' +
              '<img src="' + imgUrl(img, '120x') + '" alt="" loading="lazy">' +
            '</button>';
          }).join('') +
        '</div>';

      /* thumb clicks */
      gallery.querySelectorAll('.qv-gallery__thumb').forEach(function (btn) {
        btn.addEventListener('click', function () {
          document.getElementById('qv-main-img').src = btn.dataset.full;
          gallery.querySelectorAll('.qv-gallery__thumb').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
        });
      });

      /* zoom on hover (desktop) */
      var mainImg = gallery.querySelector('.qv-gallery__main-img');
      var mainWrap = gallery.querySelector('.qv-gallery__main');
      if (mainImg && mainWrap) {
        mainWrap.addEventListener('mousemove', function (e) {
          var rect = mainWrap.getBoundingClientRect();
          var x = ((e.clientX - rect.left) / rect.width) * 100;
          var y = ((e.clientY - rect.top)  / rect.height) * 100;
          mainImg.style.transformOrigin = x + '% ' + y + '%';
          mainImg.style.transform = 'scale(2)';
        });
        mainWrap.addEventListener('mouseleave', function () {
          mainImg.style.transform = 'scale(1)';
        });
      }
    } else {
      gallery.innerHTML = '<div class="qv-gallery__empty">No image</div>';
    }

    /* ── Info ── */
    /* badge */
    var badgeHtml = '';
    if (!selectedVariant.available) {
      badgeHtml = '<span class="qv-badge qv-badge--sold">Sold Out</span>';
    } else if (product.tags && product.tags.indexOf('new') !== -1) {
      badgeHtml = '<span class="qv-badge qv-badge--new">New</span>';
    }

    /* compare price */
    var priceHtml = '<span class="qv-price__current" id="qv-price">' + moneyFormat(selectedVariant.price) + '</span>';
    if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
      var saving = Math.round((1 - selectedVariant.price / selectedVariant.compare_at_price) * 100);
      priceHtml +=
        '<span class="qv-price__compare">' + moneyFormat(selectedVariant.compare_at_price) + '</span>' +
        '<span class="qv-price__save">−' + saving + '%</span>';
    }

    /* options */
    var optionsHtml = product.options.map(function (option, oi) {
      var unique = product.variants
        .map(function (v) { return v.options[oi]; })
        .filter(function (v, i, a) { return a.indexOf(v) === i; });

      var optName = typeof option === 'object' ? option.name : option;
      var isColor = /colou?r|shade|لون/i.test(optName);

      return '<div class="qv-option">' +
        '<div class="qv-option__label">' + optName +
          '<span class="qv-option__selected" id="qv-opt-val-' + oi + '">' + selectedVariant.options[oi] + '</span>' +
        '</div>' +
        '<div class="qv-option__values">' +
        unique.map(function (val) {
          var avail = product.variants.some(function (v) { return v.options[oi] === val && v.available; });
          var isSelected = selectedVariant.options[oi] === val;
          if (isColor) {
            var colorMap = {
              'black':'#111110','white':'#f5f5f5','brown':'#6b3a2a',
              'light brown':'#c8956c','dark brown':'#3b1f14',
              'gold':'#c9a96e','silver':'#b0b0b0','grey':'#888',
              'gray':'#888','blue':'#2563eb','red':'#dc2626',
              'green':'#16a34a','pink':'#ec4899','purple':'#9333ea',
              'orange':'#ea580c','yellow':'#ca8a04','beige':'#d4b896',
              'tortoise':'#7a4419','transparent':'rgba(200,200,200,0.3)',
              'clear':'rgba(200,200,200,0.3)'
            };
            var colorKey = val.toLowerCase().trim();
            var bgColor = colorMap[colorKey] || '#ccc';
            var textColor = ['white','silver','beige','light brown','yellow','clear','transparent'].indexOf(colorKey) !== -1 ? '#333' : '#fff';
            return '<button type="button" class="qv-swatch' + (isSelected ? ' is-selected' : '') + (!avail ? ' is-unavailable' : '') + '" ' +
              'data-option-index="' + oi + '" data-value="' + val + '" title="' + val + '" ' +
              'style="background:' + bgColor + ';border-color:' + (isSelected ? '#111110' : 'transparent') + '">' +
              '<span class="sr-only">' + val + '</span></button>';
          }
          return '<button type="button" class="qv-variant-btn' + (isSelected ? ' is-selected' : '') + (!avail ? ' is-unavailable' : '') + '" ' +
            'data-option-index="' + oi + '" data-value="' + val + '">' + val + '</button>';
        }).join('') +
        '</div></div>';
    }).join('');

    /* trust badges */
    var trustHtml =
      '<div class="qv-trust">' +
        '<div class="qv-trust__item">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--c-gold-light)" stroke-width="1.5"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>' +
          'Authentic & Guaranteed' +
        '</div>' +
        '<div class="qv-trust__item">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--c-gold-light)" stroke-width="1.5"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>' +
          '2–4 Business Days Delivery' +
        '</div>' +
        '<div class="qv-trust__item">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--c-gold-light)" stroke-width="1.5"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>' +
          'Cash on Delivery' +
        '</div>' +
      '</div>';

    info.innerHTML =
      '<div class="qv-info__top">' +
        (badgeHtml ? '<div class="qv-badges">' + badgeHtml + '</div>' : '') +
        '<div class="qv-vendor">' + (product.vendor || '') + '</div>' +
        '<h2 class="qv-title">' + product.title + '</h2>' +
        '<div class="qv-price">' + priceHtml + '</div>' +
      '</div>' +
      '<div class="qv-info__options">' + optionsHtml + '</div>' +
      '<div class="qv-info__actions">' +
        '<form action="/cart/add" method="post" id="qv-form">' +
          '<input type="hidden" name="id" id="qv-variant-id" value="' + selectedVariant.id + '">' +
          '<button type="submit" class="qv-atc-btn" id="qv-atc" data-atc-fly="true">' +
            (selectedVariant.available
              ? '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>Add to Cart'
              : 'Sold Out') +
          '</button>' +
        '</form>' +
        '<a href="/products/' + product.handle + '" class="qv-full-link">View Full Details →</a>' +
      '</div>' +
      trustHtml;

    /* option interactions */
    info.querySelectorAll('[data-option-index]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var oi = parseInt(btn.dataset.optionIndex, 10);
        selectedOptions[oi] = btn.dataset.value;

        info.querySelectorAll('[data-option-index="' + oi + '"]').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');

        var valLabel = document.getElementById('qv-opt-val-' + oi);
        if (valLabel) valLabel.textContent = btn.dataset.value;

        var match = product.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === selectedOptions[i]; });
        });
        if (match) {
          selectedVariant = match;
          document.getElementById('qv-variant-id').value = match.id;
          var priceEl = document.getElementById('qv-price');
          if (priceEl) priceEl.textContent = moneyFormat(match.price);
          var atcBtn = document.getElementById('qv-atc');
          if (atcBtn) {
            atcBtn.disabled = !match.available;
            atcBtn.innerHTML = match.available
              ? '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>Add to Cart'
              : 'Sold Out';
          }
          /* swap gallery image if variant has one */
          if (match.featured_image) {
            var mainImg = document.getElementById('qv-main-img');
            if (mainImg) mainImg.src = imgUrl(match.featured_image.src, '900x');
          }
        }
      });
    });

    /* ATC form intercept */
    var form = document.getElementById('qv-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = document.getElementById('qv-atc');
        var origHtml = btn.innerHTML;
        btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="20 6 9 17 4 12"/></svg>Added!';
        btn.style.background = '#2a6e3f';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(document.getElementById('qv-variant-id').value), quantity: 1 })
        }).then(function () {
          setTimeout(function () {
            btn.innerHTML = origHtml;
            btn.style.background = '';
            closeModal();
            /* open cart drawer if exists */
            var cartToggle = document.querySelector('[data-cart-toggle], #cart-toggle');
            if (cartToggle) cartToggle.click();
          }, 1200);
        }).catch(function () {
          btn.innerHTML = origHtml;
          btn.style.background = '';
        });
      });
    }
  }

  window.CATCHY = window.CATCHY || {};
  window.CATCHY.openQuickView = openQuickView;
})();
